import { defineStore } from 'pinia';

import type { RequestPdfParams } from '@/apis/pdf';

import * as PdfApi from '@/apis/pdf';

export interface PdfStoreState {
  instagramReportPending: boolean;
  instagramFeedReportPending: boolean;
  instagramStoryNarrativeReportPending: boolean;
  instagramStoryFramesReportPending: boolean;
  instagramStoryMetricsReportPending: boolean;
  instagramStoryOverviewReportPending: boolean;
  instagramStoryBoardsReportPending: boolean;
  twitterReportPending: boolean;
  twitterDashboardReportPending: boolean;
  pinterestReportPending: boolean;
  facebookReportPending: boolean;
  facebookDashboardReportPending: boolean;
  pinFollowerReportPending: boolean;
  engagementReportPending: boolean;
  yourPinsReportPending: boolean;
  DHBoardReportPending: boolean;
  DHBoardsReportPending: boolean;
  galleryReportPending: boolean;
  trendGroupReportPending: boolean;
  AdBoardReportPending: boolean;
  AdBoardsReportPending: boolean;
  AccountOverviewReportPending: boolean;
  YourPostsReportPending: boolean;
  relationshipsOverviewReportPending: boolean;
  relationshipsDetailReportPending: boolean;
  dashboardReportPending: boolean;
  instagramOverviewReportPending: boolean;
  campaignReportPending: boolean;
  socialListeningTrendsReportPending: boolean;
  socialListeningTopicReportPending: boolean;
  landingPageReportPending: boolean;
  [key: `${string}ReportPending`]: boolean;
}

export const usePdfStore = defineStore('pdf', {
  state: (): PdfStoreState => ({
    instagramReportPending: false,
    instagramFeedReportPending: false,
    instagramStoryNarrativeReportPending: false,
    instagramStoryFramesReportPending: false,
    instagramStoryMetricsReportPending: false,
    instagramStoryOverviewReportPending: false,
    instagramStoryBoardsReportPending: false,
    twitterReportPending: false,
    twitterDashboardReportPending: false,
    pinterestReportPending: false,
    facebookReportPending: false,
    facebookDashboardReportPending: false,
    pinFollowerReportPending: false,
    engagementReportPending: false,
    yourPinsReportPending: false,
    DHBoardReportPending: false,
    DHBoardsReportPending: false,
    galleryReportPending: false,
    trendGroupReportPending: false,
    AdBoardReportPending: false,
    AdBoardsReportPending: false,
    AccountOverviewReportPending: false,
    YourPostsReportPending: false,
    relationshipsOverviewReportPending: false,
    relationshipsDetailReportPending: false,
    dashboardReportPending: false,
    instagramOverviewReportPending: false,
    campaignReportPending: false,
    socialListeningTrendsReportPending: false,
    socialListeningTopicReportPending: false,
    landingPageReportPending: false,
  }),
  actions: {
    receiveReport(type: string | null) {
      if (type) (this as PdfStoreState)[`${type}ReportPending`] = false;
    },
    async getPdfV2({
      url,
      filename,
      notificationSocketId,
      notificationMeta,
      width,
      height,
      format,
      landscape,
      scale,
      idleTimeout,
      idleMaxInflightRequest,
      useWaitFor,
      margin,
    }: RequestPdfParams) {
      const { type } = JSON.parse(notificationMeta!);
      (this as PdfStoreState)[`${type}ReportPending`] = true;
      try {
        await PdfApi.requestPdf({
          url,
          filename,
          notificationSocketId,
          notificationMeta,
          width,
          height,
          format,
          landscape,
          scale,
          idleTimeout,
          idleMaxInflightRequest,
          useWaitFor,
          margin,
        });
      } catch (err) {
        (this as PdfStoreState)[`${type}ReportPending`] = false;
        throw err;
      }
    },
  },
});
